import i18n from '@dms/i18n';
import {SettingsTemplate} from '@dms/settings/shared';

import {AutostacjaSettingsList} from './components/AutostacjaSettingsList';

export function AutostacjaSettings() {
  return (
    <SettingsTemplate
      data-testid="integrations-autostacja-settings"
      header={{title: i18n.t('page.integrations.labels.autostacja')}}
    >
      <AutostacjaSettingsList />
    </SettingsTemplate>
  );
}
